import { api } from "../../utils/api";

export const getSales = async (data, type) => {
  try {
    const response = await api.get(`sale?action=${type}`, data && { params: data });
    return response.data;
  } catch (error) {
    throw error;
  }
};